export const HOME = '/'
export const QUIZ = '/quiz'
export const QUIZ_SUMMARY = '/summary'
